import { IntegerStepperWidget } from '@tableau/widgets';
import { useFormikContext } from 'formik';
import * as React from 'react';
import { useCallback } from 'react';

import { ByteSizeConversionFactor } from '../../../../../../src/commonInfra/utils/SizeFilter';
import { Messages } from '../../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../../commonInfra/components/FormikCheckbox';
import { PersonalSpaceSectionProps } from './PersonalSpaceSection';

export const PERSONAL_SPACE_STORAGE_QUOTA_SET_FIELD = 'settings.sitePersonalSpaceSettings.personalSpaceStorageQuotaSet';
export const PERSONAL_SPACE_STORAGE_QUOTA_FIELD = 'settings.sitePersonalSpaceSettings.personalSpaceStorageQuota';


export function PersonalSpaceEnabledOption(props: PersonalSpaceSectionProps) {
    const formik = useFormikContext<PersonalSpaceSectionProps>();
    const storageQuota = sizeInMegabytesFormatter(formik.values.settings.sitePersonalSpaceSettings.personalSpaceStorageQuota);
    const disabled = !formik.values.settings.sitePersonalSpaceSettings.personalSpaceEnabled;
    const defaultStorageQuotaValue = 2048 * ByteSizeConversionFactor.ONE_MB;

    React.useEffect(
      () => {
        if (!formik.initialValues.settings.sitePersonalSpaceSettings.personalSpaceEnabled) {
          formik.setFieldValue(PERSONAL_SPACE_STORAGE_QUOTA_SET_FIELD, true);
        }
      },
      // This noncompliance existed before the lint rule was enabled.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    if (formik.values.settings.sitePersonalSpaceSettings.personalSpaceStorageQuotaSet
        && !storageQuota) {
        formik.setFieldValue(PERSONAL_SPACE_STORAGE_QUOTA_FIELD, defaultStorageQuotaValue);
    }

    const handleChange = useCallback((value: number) => formik.setFieldValue(PERSONAL_SPACE_STORAGE_QUOTA_FIELD, isNaN(+value) ? +value : value * ByteSizeConversionFactor.ONE_MB), [formik]);
    return (
        <>
            <div>{Messages.personalSpaceSiteSettingEnabled()}</div>
            <div>{Messages.personalSpaceSiteSettingEnabledDescription()}</div>
            <FormikCheckbox name={PERSONAL_SPACE_STORAGE_QUOTA_SET_FIELD}
                label={Messages.personalSpaceCheckboxLabel()}
                testId={'allow-personal-space-storage-quota-checkbox'}
                disabled={disabled}>
                <IntegerStepperWidget
                    disabled={disabled}
                    max={102400}
                    min={1}
                    start={storageQuota ? storageQuota : defaultStorageQuotaValue}
                    delta={100}
                    testId={'personal-space-storage-quota-increment'}
                    onValueUpdated={(value: number) => { handleChange(value); }}
                />
                <span>{Messages.personalSpaceStorageQuotaPerUser()}</span>
            </FormikCheckbox>

        </>
    );
}

function sizeInMegabytesFormatter(value: number) {
  return value/ByteSizeConversionFactor.ONE_MB;
}
